import React from 'react';
import classNames from 'classnames';
import { Button as CommonButton } from '@ln/common-ui-button';
import { Drawer, toggleDrawer } from '@ln/common-ui-drawer';
import { Icon } from '@ln/common-ui-icon';
import { CloseIcon } from '@ln/experiencias-ui-assets';
import { Text } from '@ln/common-ui-text';
import './DrawerSidebar.scss';
import Nav from '../Nav';
export function DrawerSidebar () {
    const drawerId = "DrawerSidebar";
    const closeDrawer = () => toggleDrawer({ id: drawerId });
    return (
        <Drawer
            id={drawerId}
            position={'left'}
            className="max-w-520_md bg-neutral-light-1 gap-16 p-16 p-24_md shadow-down-md transition-regular"
            overlayClasses="z-10"
            handleClose={closeDrawer}
        >
            <Drawer.Header>
                <Text className='prumo prumo-semibold text-24 text-28_md text-32_lg'>Menú</Text>
                <CommonButton
                    title="Cerrar menú"
                    className="ml-auto bg-transparent"
                    onClick={closeDrawer}
                    >
                    <Icon size={24}>
                        <CloseIcon />
                    </Icon>
                </CommonButton>
            </Drawer.Header>
            <hr className='w-100 bg-neutral-light-50 hrHeight' />
            <Drawer.Body className={classNames("flex flex-column gap-16 ai-stretch")}>
                <Nav closeMenu={closeDrawer}/>
            </Drawer.Body>
        </Drawer>
    );
};
export default DrawerSidebar;